import { render, staticRenderFns } from "./NeedsApp.vue?vue&type=template&id=d4134aae&"
import script from "./NeedsApp.vue?vue&type=script&lang=js&"
export * from "./NeedsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedsApp.vue"
export default component.exports